import { render, staticRenderFns } from "./CustomColumnValues.vue?vue&type=template&id=0fd2b00c&scoped=true"
import script from "./CustomColumnValues.vue?vue&type=script&lang=ts"
export * from "./CustomColumnValues.vue?vue&type=script&lang=ts"
import style0 from "./CustomColumnValues.vue?vue&type=style&index=0&id=0fd2b00c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd2b00c",
  null
  
)

export default component.exports